module.exports = "<app-office [officeDrt]=\"1\"></app-office>"